import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { ProductVisibilityType } from "@omni/types/api/product/bff/shared/enums/productVisibilityType.enum";

import { getAllowedDeliveryTypes } from "@/utils/deliveryMethod";

import DeliveryTypesComponent from "./deliveryTypes.component";

type DeliveryTypesProps = {
    productVisibilityType: ProductVisibilityType;
    className?: string;
};

const DeliveryTypes = ({
    productVisibilityType,
    className
}: DeliveryTypesProps) => {
    const deliveryTypes = getAllowedDeliveryTypes(productVisibilityType);

    const allowClickAndCollect = deliveryTypes.includes(
        DeliveryType.ClickAndCollect
    );
    const allowHomeDelivery = deliveryTypes.includes(DeliveryType.HomeDelivery);

    return (
        <DeliveryTypesComponent
            className={className}
            allowClickAndCollect={allowClickAndCollect}
            allowHomeDelivery={allowHomeDelivery}
        />
    );
};

export { DeliveryTypes };
